import { render, staticRenderFns } from "./ComboResponsavelLead.vue?vue&type=template&id=72d28b06"
import script from "./ComboResponsavelLead.vue?vue&type=script&lang=ts"
export * from "./ComboResponsavelLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports